import apiClient from "@/clients/apiClient";

// Método para generar y descargar el PDF
export async function GeneratePedidoPdfAction(
    PedidoId: string
): Promise<void> {
    const response = await apiClient.get(`gpedPedido/${PedidoId}/pdf`, {
        responseType: 'blob',
        headers: {
            'Accept': 'application/pdf'
        }
    });
    
    // Crear URL del blob
    const blob = new Blob([response.data], { type: 'application/pdf' });
    const url = window.URL.createObjectURL(blob);
    
    // Crear link y descargar
    const link = document.createElement('a');
    link.href = url;
    link.download = `pedido-${PedidoId}.pdf`;
    document.body.appendChild(link);
    link.click();
    
    // Limpiar
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
}